<template>

  <div id="app" :class="['gridcontainer', sidebarClass]" >
    <header>
      <StratosHeader v-if="enableHeader"/>
    </header>

    <nav class="mynavbar">
      <div v-if="enableNavSidebar" id="sidebar" v-bind:class="{ active: isNavBarActive }">
        <div class="sidebarToggleRow">
          <b-button variant="link" squared block class="shadow-none expanderButton" @click="toggleSidebar">
            <v-icon v-if="isNavBarActive" scale="3" name="angle-double-right"> </v-icon>
            <v-icon v-else scale="3" name="angle-double-left"></v-icon>
          </b-button>
        </div>
        <NavSidebar :expanded="!isNavBarActive"/>
      </div>
    </nav>

    <main>
      <v-idle v-if="getIdleTimeout>0" :duration="getIdleTimeout" @idle="onIdle" v-show="false"/>
      <router-view :key="$route.fullPath"></router-view>
    </main>

    <aside>
      <div v-if="enableNavSidebar" id="filterbar" v-bind:class="{ active: isFilterBarExpanded }">

        <b-button variant="link" squared block class="shadow-none expanderButton" @click="toggleFilterbar">
          <v-icon :color="filterIconColor" scale="2" name="filter"> </v-icon>
        </b-button>

        <FilterSidebar :expanded="isFilterBarExpanded"/>

      </div>
    </aside>

    <footer class="footer">
      <!-- Footer content -->
    </footer>

  </div>

</template>

<script>
import {mapGetters, mapState} from "vuex";

import NavSidebar from "./components/NavSidebar";
import StratosHeader from "./components/StratosHeader";
import FilterSidebar from "./components/FilterSidebar";
export default {

  components: {FilterSidebar, StratosHeader, NavSidebar},

  data() {
    return {
      isNavBarActive: true,
//        isFilterBarActive: false
    }
  },

  computed: {
    ...mapState(['isFilterBarExpanded']),
    ...mapGetters(['isVarFiltersSelected', 'getIdleTimeout']),

    sidebarClass() {
      if(this.enableNavSidebar) {
        return this.isNavBarActive ? 'navBarCompact' : 'navBarWide'
      }

      return "noSideBars"
    },

    enableHeader() {
      return !this.$route.meta.hideHeader
    },

    enableNavSidebar() {
      return !this.$route.meta.hideNavSidebar
    },

    filterIconColor() {
      return this.isVarFiltersSelected ? "red" : "#dddddd"
    }

  },

  methods: {
    toggleSidebar: function () {
      this.isNavBarActive = !this.isNavBarActive
      this.$store.commit('increaseChartRedrawCounter')
    },

    toggleFilterbar: function () {
      this.$store.commit('toggleFilterBarExpanded')
      this.$store.commit('increaseChartRedrawCounter')
    },

    onIdle: function () {
      this.$store.commit('logout')
      this.$router.push('/')
    }

  }
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.expanderButton {
  color: #dddddd !important;
}

.expanderButton:hover {
  color: white !important;
}


.gridcontainer {
  display: grid;

  grid-template-areas:
          "header header header"
          "nav content side"
          "footer footer footer";

  grid-template-rows: auto 1fr auto;
  grid-gap: 0;
  height: 100vh;
}

.noSideBars {
  grid-template-columns: auto 3fr auto;
}

.navBarCompact {
  grid-template-columns: 64px 3fr auto;
}

.navBarWide {
  grid-template-columns: 250px 3fr auto;
}



header {
  grid-area: header;
}

.mynavbar {
  grid-area: nav;
  background-color: #757575;
}

main {
  grid-area: content;
  background-color: #e5e5e5;
  overflow-x: hidden;
}

aside {
  grid-area: side;
  background-color: #757575;
}

footer {
  grid-area: footer;
}

div.sidebarToggleRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

i,
span {
  display: inline-block;
}

</style>
